/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddContentSubscriberRequest,
    AddUserToUpcomingShowCommentDenylist,
    CommentUpvoteItem,
    CommentUpvotersResponse,
    CreateTipRequest,
    CreateUpcomingShowBySellerDto,
    CreateUpcomingShowDto,
    IdResponse,
    MostUpvotedCommentResponse,
    MostUpvotedCommentResponseWrapper,
    PatchUpcomingShowDto,
    SendCommentRequest,
    UpcomingShowGenerateTokenRequest,
    UpcomingShowResponse,
    UpcomingShowTokensResponse,
    UpdateTipRequest,
    UpdateUpcomingShowDto,
    WaveFollowersToWatchRequest,
    WavedToUserEnterRequest,
} from '../models';

export interface UpcomingShowApiControllerAddUpcomingShowContentSubscriberRequest {
    upcomingShowId: string;
    addContentSubscriberRequest: AddContentSubscriberRequest;
}

export interface UpcomingShowApiControllerAddUserToUpcomingShowCommentDenylistRequest {
    upcomingShowId: string;
    userId: string;
    addUserToUpcomingShowCommentDenylist: AddUserToUpcomingShowCommentDenylist;
}

export interface UpcomingShowApiControllerCreateTipRequest {
    upcomingShowId: string;
    createTipRequest: CreateTipRequest;
}

export interface UpcomingShowApiControllerCreateUpcomingShowRequest {
    upcomingShowId: string;
    createUpcomingShowDto: CreateUpcomingShowDto;
}

export interface UpcomingShowApiControllerCreateUpcomingShowBySellerRequest {
    sellerId: string;
    createUpcomingShowBySellerDto: CreateUpcomingShowBySellerDto;
}

export interface UpcomingShowApiControllerCreateViewerRequest {
    upcomingShowId: string;
}

export interface UpcomingShowApiControllerDeleteCommentRequest {
    upcomingShowId: string;
    commentId: string;
}

export interface UpcomingShowApiControllerDeleteUpcomingShowRequest {
    upcomingShowId: string;
}

export interface UpcomingShowApiControllerGenerateTokensRequest {
    upcomingShowId: string;
    upcomingShowGenerateTokenRequest: UpcomingShowGenerateTokenRequest;
}

export interface UpcomingShowApiControllerGetCommentUpvotersRequest {
    upcomingShowId: string;
    commentId: string;
    limit: number;
}

export interface UpcomingShowApiControllerGetCommentUpvotesRequest {
    upcomingShowId: string;
    sinceMinutesAgo?: number;
}

export interface UpcomingShowApiControllerGetMostUpvotedCommentRequest {
    upcomingShowId: string;
}

export interface UpcomingShowApiControllerGetMostUpvotedCommentV2Request {
    upcomingShowId: string;
}

export interface UpcomingShowApiControllerPatchUpcomingShowRequest {
    upcomingShowId: string;
    patchUpcomingShowDto: PatchUpcomingShowDto;
}

export interface UpcomingShowApiControllerRemoveTipRequest {
    upcomingShowId: string;
    tipId: string;
}

export interface UpcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylistRequest {
    upcomingShowId: string;
    userId: string;
}

export interface UpcomingShowApiControllerSendCommentRequest {
    upcomingShowId: string;
    commentId: string;
    sendCommentRequest: SendCommentRequest;
}

export interface UpcomingShowApiControllerUpdateTipRequest {
    upcomingShowId: string;
    tipId: string;
    updateTipRequest: UpdateTipRequest;
}

export interface UpcomingShowApiControllerUpdateUpcomingShowRequest {
    upcomingShowId: string;
    updateUpcomingShowDto: UpdateUpcomingShowDto;
}

export interface UpcomingShowApiControllerUpvoteCommentRequest {
    upcomingShowId: string;
    commentId: string;
}

export interface UpcomingShowApiControllerWaveFollowersToWatchRequest {
    upcomingShowId: string;
    waveFollowersToWatchRequest: WaveFollowersToWatchRequest;
}

export interface UpcomingShowApiControllerWavedToUserEnterRequest {
    upcomingShowId: string;
    wavedToUserEnterRequest: WavedToUserEnterRequest;
}

/**
 * 
 */
export class UpcomingShowApi extends runtime.BaseAPI {

    /**
     */
    async upcomingShowApiControllerAddUpcomingShowContentSubscriberRaw(requestParameters: UpcomingShowApiControllerAddUpcomingShowContentSubscriberRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerAddUpcomingShowContentSubscriber.');
        }

        if (requestParameters.addContentSubscriberRequest === null || requestParameters.addContentSubscriberRequest === undefined) {
            throw new runtime.RequiredError('addContentSubscriberRequest','Required parameter requestParameters.addContentSubscriberRequest was null or undefined when calling upcomingShowApiControllerAddUpcomingShowContentSubscriber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/content-subscribers`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addContentSubscriberRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerAddUpcomingShowContentSubscriber(requestParameters: UpcomingShowApiControllerAddUpcomingShowContentSubscriberRequest): Promise<void> {
        await this.upcomingShowApiControllerAddUpcomingShowContentSubscriberRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerAddUserToUpcomingShowCommentDenylistRaw(requestParameters: UpcomingShowApiControllerAddUserToUpcomingShowCommentDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerAddUserToUpcomingShowCommentDenylist.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling upcomingShowApiControllerAddUserToUpcomingShowCommentDenylist.');
        }

        if (requestParameters.addUserToUpcomingShowCommentDenylist === null || requestParameters.addUserToUpcomingShowCommentDenylist === undefined) {
            throw new runtime.RequiredError('addUserToUpcomingShowCommentDenylist','Required parameter requestParameters.addUserToUpcomingShowCommentDenylist was null or undefined when calling upcomingShowApiControllerAddUserToUpcomingShowCommentDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/blocked/{userId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addUserToUpcomingShowCommentDenylist,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerAddUserToUpcomingShowCommentDenylist(requestParameters: UpcomingShowApiControllerAddUserToUpcomingShowCommentDenylistRequest): Promise<void> {
        await this.upcomingShowApiControllerAddUserToUpcomingShowCommentDenylistRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerCreateTipRaw(requestParameters: UpcomingShowApiControllerCreateTipRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerCreateTip.');
        }

        if (requestParameters.createTipRequest === null || requestParameters.createTipRequest === undefined) {
            throw new runtime.RequiredError('createTipRequest','Required parameter requestParameters.createTipRequest was null or undefined when calling upcomingShowApiControllerCreateTip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/tips`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTipRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerCreateTip(requestParameters: UpcomingShowApiControllerCreateTipRequest): Promise<IdResponse> {
        const response = await this.upcomingShowApiControllerCreateTipRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async upcomingShowApiControllerCreateUpcomingShowRaw(requestParameters: UpcomingShowApiControllerCreateUpcomingShowRequest): Promise<runtime.ApiResponse<UpcomingShowResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerCreateUpcomingShow.');
        }

        if (requestParameters.createUpcomingShowDto === null || requestParameters.createUpcomingShowDto === undefined) {
            throw new runtime.RequiredError('createUpcomingShowDto','Required parameter requestParameters.createUpcomingShowDto was null or undefined when calling upcomingShowApiControllerCreateUpcomingShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUpcomingShowDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerCreateUpcomingShow(requestParameters: UpcomingShowApiControllerCreateUpcomingShowRequest): Promise<UpcomingShowResponse> {
        const response = await this.upcomingShowApiControllerCreateUpcomingShowRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async upcomingShowApiControllerCreateUpcomingShowBySellerRaw(requestParameters: UpcomingShowApiControllerCreateUpcomingShowBySellerRequest): Promise<runtime.ApiResponse<UpcomingShowResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling upcomingShowApiControllerCreateUpcomingShowBySeller.');
        }

        if (requestParameters.createUpcomingShowBySellerDto === null || requestParameters.createUpcomingShowBySellerDto === undefined) {
            throw new runtime.RequiredError('createUpcomingShowBySellerDto','Required parameter requestParameters.createUpcomingShowBySellerDto was null or undefined when calling upcomingShowApiControllerCreateUpcomingShowBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/upcoming-shows`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUpcomingShowBySellerDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerCreateUpcomingShowBySeller(requestParameters: UpcomingShowApiControllerCreateUpcomingShowBySellerRequest): Promise<UpcomingShowResponse> {
        const response = await this.upcomingShowApiControllerCreateUpcomingShowBySellerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async upcomingShowApiControllerCreateViewerRaw(requestParameters: UpcomingShowApiControllerCreateViewerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerCreateViewer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/viewers`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerCreateViewer(requestParameters: UpcomingShowApiControllerCreateViewerRequest): Promise<void> {
        await this.upcomingShowApiControllerCreateViewerRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerDeleteCommentRaw(requestParameters: UpcomingShowApiControllerDeleteCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerDeleteComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling upcomingShowApiControllerDeleteComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/comments/{commentId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerDeleteComment(requestParameters: UpcomingShowApiControllerDeleteCommentRequest): Promise<void> {
        await this.upcomingShowApiControllerDeleteCommentRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerDeleteUpcomingShowRaw(requestParameters: UpcomingShowApiControllerDeleteUpcomingShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerDeleteUpcomingShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerDeleteUpcomingShow(requestParameters: UpcomingShowApiControllerDeleteUpcomingShowRequest): Promise<void> {
        await this.upcomingShowApiControllerDeleteUpcomingShowRaw(requestParameters);
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGenerateTokensRaw(requestParameters: UpcomingShowApiControllerGenerateTokensRequest): Promise<runtime.ApiResponse<UpcomingShowTokensResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerGenerateTokens.');
        }

        if (requestParameters.upcomingShowGenerateTokenRequest === null || requestParameters.upcomingShowGenerateTokenRequest === undefined) {
            throw new runtime.RequiredError('upcomingShowGenerateTokenRequest','Required parameter requestParameters.upcomingShowGenerateTokenRequest was null or undefined when calling upcomingShowApiControllerGenerateTokens.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}:generateTokens`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.upcomingShowGenerateTokenRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGenerateTokens(requestParameters: UpcomingShowApiControllerGenerateTokensRequest): Promise<UpcomingShowTokensResponse> {
        const response = await this.upcomingShowApiControllerGenerateTokensRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetCommentUpvotersRaw(requestParameters: UpcomingShowApiControllerGetCommentUpvotersRequest): Promise<runtime.ApiResponse<CommentUpvotersResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerGetCommentUpvoters.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling upcomingShowApiControllerGetCommentUpvoters.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling upcomingShowApiControllerGetCommentUpvoters.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/comments/{commentId}/upvoters`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetCommentUpvoters(requestParameters: UpcomingShowApiControllerGetCommentUpvotersRequest): Promise<CommentUpvotersResponse> {
        const response = await this.upcomingShowApiControllerGetCommentUpvotersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetCommentUpvotesRaw(requestParameters: UpcomingShowApiControllerGetCommentUpvotesRequest): Promise<runtime.ApiResponse<Array<CommentUpvoteItem>>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerGetCommentUpvotes.');
        }

        const queryParameters: any = {};

        if (requestParameters.sinceMinutesAgo !== undefined) {
            queryParameters['sinceMinutesAgo'] = requestParameters.sinceMinutesAgo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/comment-upvotes`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetCommentUpvotes(requestParameters: UpcomingShowApiControllerGetCommentUpvotesRequest): Promise<Array<CommentUpvoteItem>> {
        const response = await this.upcomingShowApiControllerGetCommentUpvotesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetMostUpvotedCommentRaw(requestParameters: UpcomingShowApiControllerGetMostUpvotedCommentRequest): Promise<runtime.ApiResponse<MostUpvotedCommentResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerGetMostUpvotedComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/comments:getMostUpvoted`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetMostUpvotedComment(requestParameters: UpcomingShowApiControllerGetMostUpvotedCommentRequest): Promise<MostUpvotedCommentResponse> {
        const response = await this.upcomingShowApiControllerGetMostUpvotedCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetMostUpvotedCommentV2Raw(requestParameters: UpcomingShowApiControllerGetMostUpvotedCommentV2Request): Promise<runtime.ApiResponse<MostUpvotedCommentResponseWrapper>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerGetMostUpvotedCommentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/upcoming-shows/{upcomingShowId}/comments:getMostUpvoted`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async upcomingShowApiControllerGetMostUpvotedCommentV2(requestParameters: UpcomingShowApiControllerGetMostUpvotedCommentV2Request): Promise<MostUpvotedCommentResponseWrapper> {
        const response = await this.upcomingShowApiControllerGetMostUpvotedCommentV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async upcomingShowApiControllerPatchUpcomingShowRaw(requestParameters: UpcomingShowApiControllerPatchUpcomingShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerPatchUpcomingShow.');
        }

        if (requestParameters.patchUpcomingShowDto === null || requestParameters.patchUpcomingShowDto === undefined) {
            throw new runtime.RequiredError('patchUpcomingShowDto','Required parameter requestParameters.patchUpcomingShowDto was null or undefined when calling upcomingShowApiControllerPatchUpcomingShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchUpcomingShowDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerPatchUpcomingShow(requestParameters: UpcomingShowApiControllerPatchUpcomingShowRequest): Promise<void> {
        await this.upcomingShowApiControllerPatchUpcomingShowRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerRemoveTipRaw(requestParameters: UpcomingShowApiControllerRemoveTipRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerRemoveTip.');
        }

        if (requestParameters.tipId === null || requestParameters.tipId === undefined) {
            throw new runtime.RequiredError('tipId','Required parameter requestParameters.tipId was null or undefined when calling upcomingShowApiControllerRemoveTip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/tips/{tipId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"tipId"}}`, encodeURIComponent(String(requestParameters.tipId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerRemoveTip(requestParameters: UpcomingShowApiControllerRemoveTipRequest): Promise<void> {
        await this.upcomingShowApiControllerRemoveTipRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylistRaw(requestParameters: UpcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylist.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling upcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/blocked/{userId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylist(requestParameters: UpcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylistRequest): Promise<void> {
        await this.upcomingShowApiControllerRemoveUserFromUpcomingShowCommentDenylistRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerSendCommentRaw(requestParameters: UpcomingShowApiControllerSendCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerSendComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling upcomingShowApiControllerSendComment.');
        }

        if (requestParameters.sendCommentRequest === null || requestParameters.sendCommentRequest === undefined) {
            throw new runtime.RequiredError('sendCommentRequest','Required parameter requestParameters.sendCommentRequest was null or undefined when calling upcomingShowApiControllerSendComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/comments/{commentId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendCommentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerSendComment(requestParameters: UpcomingShowApiControllerSendCommentRequest): Promise<void> {
        await this.upcomingShowApiControllerSendCommentRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerUpdateTipRaw(requestParameters: UpcomingShowApiControllerUpdateTipRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerUpdateTip.');
        }

        if (requestParameters.tipId === null || requestParameters.tipId === undefined) {
            throw new runtime.RequiredError('tipId','Required parameter requestParameters.tipId was null or undefined when calling upcomingShowApiControllerUpdateTip.');
        }

        if (requestParameters.updateTipRequest === null || requestParameters.updateTipRequest === undefined) {
            throw new runtime.RequiredError('updateTipRequest','Required parameter requestParameters.updateTipRequest was null or undefined when calling upcomingShowApiControllerUpdateTip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/tips/{tipId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"tipId"}}`, encodeURIComponent(String(requestParameters.tipId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateTipRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerUpdateTip(requestParameters: UpcomingShowApiControllerUpdateTipRequest): Promise<void> {
        await this.upcomingShowApiControllerUpdateTipRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerUpdateUpcomingShowRaw(requestParameters: UpcomingShowApiControllerUpdateUpcomingShowRequest): Promise<runtime.ApiResponse<UpcomingShowResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerUpdateUpcomingShow.');
        }

        if (requestParameters.updateUpcomingShowDto === null || requestParameters.updateUpcomingShowDto === undefined) {
            throw new runtime.RequiredError('updateUpcomingShowDto','Required parameter requestParameters.updateUpcomingShowDto was null or undefined when calling upcomingShowApiControllerUpdateUpcomingShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUpcomingShowDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerUpdateUpcomingShow(requestParameters: UpcomingShowApiControllerUpdateUpcomingShowRequest): Promise<UpcomingShowResponse> {
        const response = await this.upcomingShowApiControllerUpdateUpcomingShowRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async upcomingShowApiControllerUpvoteCommentRaw(requestParameters: UpcomingShowApiControllerUpvoteCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerUpvoteComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling upcomingShowApiControllerUpvoteComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/comments/{commentId}:upvote`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerUpvoteComment(requestParameters: UpcomingShowApiControllerUpvoteCommentRequest): Promise<void> {
        await this.upcomingShowApiControllerUpvoteCommentRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerWaveFollowersToWatchRaw(requestParameters: UpcomingShowApiControllerWaveFollowersToWatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerWaveFollowersToWatch.');
        }

        if (requestParameters.waveFollowersToWatchRequest === null || requestParameters.waveFollowersToWatchRequest === undefined) {
            throw new runtime.RequiredError('waveFollowersToWatchRequest','Required parameter requestParameters.waveFollowersToWatchRequest was null or undefined when calling upcomingShowApiControllerWaveFollowersToWatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}:waveFollowers`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.waveFollowersToWatchRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerWaveFollowersToWatch(requestParameters: UpcomingShowApiControllerWaveFollowersToWatchRequest): Promise<void> {
        await this.upcomingShowApiControllerWaveFollowersToWatchRaw(requestParameters);
    }

    /**
     */
    async upcomingShowApiControllerWavedToUserEnterRaw(requestParameters: UpcomingShowApiControllerWavedToUserEnterRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowApiControllerWavedToUserEnter.');
        }

        if (requestParameters.wavedToUserEnterRequest === null || requestParameters.wavedToUserEnterRequest === undefined) {
            throw new runtime.RequiredError('wavedToUserEnterRequest','Required parameter requestParameters.wavedToUserEnterRequest was null or undefined when calling upcomingShowApiControllerWavedToUserEnter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}:wavedToUserEnter`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.wavedToUserEnterRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowApiControllerWavedToUserEnter(requestParameters: UpcomingShowApiControllerWavedToUserEnterRequest): Promise<void> {
        await this.upcomingShowApiControllerWavedToUserEnterRaw(requestParameters);
    }

}
